// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "lotto-widget." + ({"18":"results","36":"picker","170":"logout","177":"home","511":"cart","577":"signin","637":"order","685":"register","791":"aviator","845":"profile","881":"password","882":"wallet","892":"mybets","909":"notifications"}[chunkId] || chunkId) + ".js";
};